import { Box, Button, Dialog, Drawer, FormControl, FormLabel, Grid, IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { ApiCreateVenueLogins, ApiDeleteVenueLogins, ApiGenerateLoginToken, ApiGetVenueList, ApiGetVenueUsers, ApiPutUpdateAdminStatus, ApiUpdateVenueLogins } from '../../../apiService/Core/Apicall.tsx'
import { CancelOutlined, Visibility, VisibilityOff } from '@mui/icons-material'
import { FormikValues, useFormik } from "formik";
import { Form } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import edit from "../../../assets/images/editIcon.png";
import DeleteIcon from "@mui/icons-material/Delete";
import { getVenueList } from '../../../apiService/Core/ApiEndPoint.tsx'




function VenueUsers() {
    const location = useLocation()
    // const { venue } = location.state
    const [venue, setVenue] = useState<any>([])
    const { id } = useParams()
    const [users, setUsers] = useState<any[]>([])
    const [isOpenAdd, setisOpenAdd] = useState<boolean>(false);
    const [isedit, setisedit] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [selecteduser, setselectedUser] = useState<number>(-1)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const adminId: any = localStorage.getItem('userId')




    const getvenueUsers = async () => {
        try {
            const data = `?venueId=${id}`
            const res = await ApiGetVenueUsers(data)
            if (res.status) {
                setUsers(res.data)
            }
        } catch (error) {
            console.log("Error", error)
        }
    }

    useEffect(() => {
        if (id) {
            getvenueUsers()
            handleGetVenueList()
        }
    }, [id])


    const handleGetVenueList = async () => {
        const data = `?venueId=${id}`;
        try {
            const response: any = await ApiGetVenueList(data);
            // const transformedData = response.data.map((item: any) => ({
            //   value: item.venueId,
            //   label: item.venueName,
            // }));
            setVenue(response?.data[0]);
        } catch (error) {
            console.error("Error during API call:", error);
        }
    };

    const initialValues = {
        venueId: id ?? "",
        emailId: isedit ? users[selecteduser]?.emailId : "",
        password: "",
        confirmpassword: "",
        // roleId: 4,
        firstName: isedit ? users[selecteduser]?.firstName : "",
        lastName: isedit ? users[selecteduser]?.lastName : "",
        contactNo: isedit ? users[selecteduser]?.contactNo : "",
        createdBy: userData.userId,
    };

    const validationSchema = Yup.object({
        emailId: Yup.string()
            .email("Invalid email format")
            .required("Email is required"),

        password: Yup.string()
            .required("Password is required")
            .min(6, "Password must be at least 6 characters")
            .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
            .matches(/[0-9]/, "Password must contain at least one number"),

        confirmpassword: Yup.string()
            .required("Confirm Password is required")
            .oneOf([Yup.ref("password")], "Passwords must match"),

        firstName: Yup.string().required("First Name is required"),

        lastName: Yup.string().required("Last Name is required"),

        contactNo: Yup.string()
            .required("Contact Number is required")
            .matches(/^[0-9]{10}$/, "Contact Number must be 10 digits"),
    });

    const onSubmit = async (values: FormikValues) => {
        const updatevalues = {
            userId: users[selecteduser]?.userId,
            password: values.password,
            displayName: `${values.firstName} ${values.lastName}`,
            // roleId: 4,
            firstName: values.firstName,
            lastName: values.lastName,
            contactNo: values.contactNo,
            updatedBy: values.createdBy,
        };

        try {
            const response = isedit
                ? await ApiUpdateVenueLogins(updatevalues)
                : await ApiCreateVenueLogins({ ...values, createdBy: Number(localStorage.getItem('createdBy')) });
            if (response.status) {
                formik.resetForm();
                // isedit
                // ? toast.success("Details updated successfully")
                // : toast.success("VenueManager added successfully");
                setisedit(false);
                setisOpenAdd(false);
                getvenueUsers();
            }
        } catch (error: any) {
            console.log("Error", error)
            const message =
                error?.response?.data?.message || error?.message || String(error);
            toast.error(message);
        }
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit,
    });

    const getClientSiteURL = (hostname: string) => {
        switch (hostname) {
            case "ALDI":
                return process.env.REACT_APP_ALDI_CLIENT_SITE;
            case "BLOOMS":
                return process.env.REACT_APP_BLOOMS_CLIENT_SITE;
            case "MM":
            case "TRANSPORT": // same URL for both
                return process.env.REACT_APP_MM_CLIENT_SITE;
            default:
                return process.env.REACT_APP_MM_CLIENT_SITE;;
        }
    }
    const navigateToLoginShopper = async (user: any) => {

        try {
            const data = {
                adminUserId: adminId,
                targetUserId: user.userId,
                ipAddress: '127.0.0.1',
                browserName: 'Google chrome'

            }
            const res = await ApiGenerateLoginToken(data)
            if (res.success) {
                window.open(`${getClientSiteURL(venue.clientEntityId.clientId.ClientGroupName.clientGroupName)}?adminuserid=${adminId}&validation=${res.data.token}`, '_blank');
            }
        } catch (error: any) {
            toast.error(error)
        }

    }

    const handleDeleteUser = async (userId: number, status: string) => {
        try {
            // const data = {
            //     userId: userId,
            //     status: status
            // }
           const data =`?userId=${userId}`
            // const response = await ApiPutUpdateAdminStatus(data);
            const response = await ApiDeleteVenueLogins(data);
            toast.success("User deleted successfully.");
            getvenueUsers();
        } catch (error) {
            console.error("Error deleting User.", error);
            toast.error("Error Deleting User.")
        }
    }

    return (
        <>
            <Box className='h-100 p-3 border bg-white' minHeight={'calc(100vh - 180px)'}>
                <Typography variant='h4' className='fw-bold text-center' gutterBottom fontWeight={600}>Manage Site Users</Typography>
                <Box className='d-flex align-items-center justify-content-between'>
                    <Typography variant='h5' gutterBottom className='fw-bold' fontWeight={600}>{venue?.venueName}</Typography>
                    <Button
                        variant="contained"
                        onClick={() => setisOpenAdd(true)}
                        className="table-row-background"
                        sx={{ textTransform: 'none' }}
                    >
                        Add Site User
                    </Button>
                </Box>
                <Grid container className='mt-4 extra'>
                    {users?.length > 0 ? users?.map((user: any, index: number) => (
                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 'auto' }} className='border p-2 px-3  border-10 ml-2'>
                            <Box className='d-flex align-items-start justify-content-between'>
                                <Box>
                                    <Typography variant='h6' fontWeight={'bold'}>{user?.displayName}</Typography>
                                    <Typography>{user?.emailId}</Typography>
                                </Box>
                                <Box className='d-flex align-items-center' gap={1}>
                                    <IconButton onClick={() => {
                                        setisOpenAdd(true);
                                        setisedit(true);
                                        setselectedUser(index);
                                    }}>
                                        <Box component="img" height={'24px'} src={edit}></Box>
                                    </IconButton>
                                    <IconButton onClick={() => {
                                        const isConfirmed = window.confirm("Are you sure you want to delete this user?")
                                        if (isConfirmed) {
                                            handleDeleteUser(user?.userId, "delete")
                                        }
                                    }}>
                                        <DeleteIcon className="delete-icon" />
                                    </IconButton>
                                </Box>
                            </Box>
                            <Button className='btn-main mt-2' onClick={() => { navigateToLoginShopper(user) }}>Login</Button>
                        </Grid>

                    )) : <Typography className='text-center w-100' variant='h6'>No users found</Typography>}
                </Grid>
            </Box>
            <Drawer
                anchor="right"
                PaperProps={{
                    sx: { width: "100%", maxWidth: "500px" },
                }}
                open={isOpenAdd}>
                <Box className="p-3 bg-white h-100 w-100">
                    <Box className={"d-flex allign-items-center justify-content-between"}>
                        <Typography variant="h5" className="mb-0" fontWeight={"bolder"}>
                            Add Site Manager
                        </Typography>
                        <IconButton
                            onClick={() => {
                                setisOpenAdd(false);
                                setisedit(false);
                            }}>
                            <CancelOutlined />
                        </IconButton>
                    </Box>
                    <hr />
                    <form className="w-100 extra" onSubmit={formik.handleSubmit}>
                        <Grid container spacing={2} className="w-100">
                            <Grid size={12}>
                                <FormControl className="rm-padding w-100">
                                    <FormLabel sx={{ fontSize: "14px" }}>First Name</FormLabel>
                                    <TextField
                                        name="firstName"
                                        placeholder='First name'
                                        className="w-100 border-20"
                                        value={formik.values.firstName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.firstName &&
                                        formik.errors.firstName &&
                                        typeof formik.errors.firstName === "string" && (
                                            <Typography variant="caption" sx={{ color: "red" }}>
                                                {formik.errors.firstName}
                                            </Typography>
                                        )}
                                </FormControl>
                            </Grid>
                            <Grid size={12}>
                                <FormControl className="rm-padding w-100">
                                    <FormLabel sx={{ fontSize: "14px" }}>Last Name</FormLabel>
                                    <TextField
                                        name="lastName"
                                        placeholder='Last name'
                                        className="w-100 border-20"
                                        value={formik.values.lastName}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.lastName &&
                                        formik.errors.lastName &&
                                        typeof formik.errors.lastName === "string" && (
                                            <Typography variant="caption" sx={{ color: "red" }}>
                                                {formik.errors.lastName}
                                            </Typography>
                                        )}
                                </FormControl>
                            </Grid>
                            <Grid size={12}>
                                <FormControl className=" w-100 rm-padding">
                                    <FormLabel sx={{ fontSize: "14px" }}>Manager Email</FormLabel>
                                    <TextField
                                        type="email"
                                        name="emailId"
                                        placeholder='Email address'
                                        className="w-100 border-20"
                                        disabled={isedit}
                                        value={formik.values.emailId}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.emailId &&
                                        formik.errors.emailId &&
                                        typeof formik.errors.emailId === "string" && (
                                            <Typography variant="caption" sx={{ color: "red" }}>
                                                {formik.errors.emailId}
                                            </Typography>
                                        )}
                                </FormControl>
                            </Grid>
                            <Grid size={12}>
                                <FormControl className=" w-100 rm-padding">
                                    <FormLabel sx={{ fontSize: "14px" }}>Contact</FormLabel>
                                    <TextField
                                        type="text"
                                        name="contactNo"
                                        placeholder='Contact number'
                                        className="w-100 border-20"
                                        value={formik.values.contactNo}
                                        onBlur={formik.handleBlur}
                                        onChange={(e) => {
                                            const onlyDigits = e.target.value.replace(/\D/g, "");
                                            formik.setFieldValue("contactNo", onlyDigits);
                                        }}
                                        inputProps={{
                                            maxLength: 10,
                                        }}
                                    />
                                    {formik.touched.emailId &&
                                        formik.errors.contactNo &&
                                        typeof formik.errors.contactNo === "string" && (
                                            <Typography variant="caption" sx={{ color: "red" }}>
                                                {formik.errors.contactNo}
                                            </Typography>
                                        )}
                                </FormControl>
                            </Grid>
                            <Grid size={12}>
                                <FormControl className="w-100 rm-padding">
                                    <FormLabel sx={{ fontSize: "14px" }}>
                                        Create Password
                                    </FormLabel>
                                    <TextField
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        placeholder='password'
                                        className="w-100 border-20"
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => setShowPassword(!showPassword)}
                                                        edge="end">
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    {formik.touched.password &&
                                        formik.errors.password &&
                                        typeof formik.errors.password === "string" && (
                                            <Typography variant="caption" sx={{ color: "red" }}>
                                                {formik.errors.password}
                                            </Typography>
                                        )}
                                </FormControl>
                            </Grid>
                            <Grid size={12}>
                                <FormControl className="w-100 rm-padding">
                                    <FormLabel sx={{ fontSize: "14px" }}>
                                        Confirm Password
                                    </FormLabel>
                                    <TextField
                                        type={showConfirmPassword ? "text" : "password"}
                                        name="confirmpassword"
                                        placeholder='Confrim password'
                                        className="w-100 border-20"
                                        value={formik.values.confirmpassword}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() =>
                                                            setShowConfirmPassword(!showConfirmPassword)
                                                        }
                                                        edge="end">
                                                        {showConfirmPassword ? (
                                                            <VisibilityOff />
                                                        ) : (
                                                            <Visibility />
                                                        )}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    {formik.touched.confirmpassword &&
                                        formik.errors.confirmpassword &&
                                        typeof formik.errors.confirmpassword === "string" && (
                                            <Typography variant="caption" sx={{ color: "red" }}>
                                                {formik.errors.confirmpassword}
                                            </Typography>
                                        )}
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Box className="d-flex justify-content-end">
                            <Button type="submit" className="table-row-background  text-white px-4 py-1 my-3">
                                {isedit ? "Update" : "Add"}
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Drawer>
        </>

    )
}

export default VenueUsers
